// A tenant can limit its navigation to a list of items (module config policies.nav_allow, by test id), e.g. a pilot
// that proves one workflow. No list means no restriction. This hides links only; the API's module gating is the
// access control.
export function navAllowed(item, allow) {
  if (!Array.isArray(allow)) return true;
  return allow.includes(item.testid);
}
